import { useState } from "react";
import Select from "react-select";
import { useUser } from "@auth0/nextjs-auth0/client";
import axios from "axios";
import Error from "@components/alert/Error";
import useAnalytics from "hooks/useAnalytics";
import { useRouter } from "next/router";

const raceOptions = [
  { value: "Black or African American", label: "Black or African American" },
  {
    value: "American Indian or Alaska Native",
    label: "American Indian or Alaska Native",
  },
  {
    value: " Native Hawaiian or Other Pacific Islander",
    label: " Native Hawaiian or Other Pacific Islander",
  },
  { value: "Hispanic/latina", label: "Hispanic/latina" },
  { value: "Other", label: "Other" },
];

const Button = ({ text, handleClick, ...rest }) => (
  <label className="custom-checkbox mb-3 mr-2">
    <input
      type="checkbox"
      defaultValue={text}
      onClick={(e) => handleClick(e)}
      {...rest}
    />
    <span className="bg-gray-200 rounded-full px-4 py-1.5 text-sm hover:bg-gray-300 transition">
      {text}
    </span>
  </label>
);

export default function StepDetails({
  setSteps,
  sourceUrl,
  setSourceUrl,
  outsetaUserId,
  slug,
}) {
  const [buttons, setButtons] = useState([]);
  const [visible, setVisible] = useState([]);
  const [otherFields, setOtherFields] = useState({});
  const [raceSelected, setRaceSelected] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const { user } = useUser();
  const { track } = useAnalytics();
  const router = useRouter();

  const handleClick = (e) => {
    if (e.target.checked) {
      setButtons((prevState) => [...prevState, e.target.value]);
      if (e.target.value === "Victim Photo" || e.target.value === "Timeline") {
        return;
      }
      setVisible((prevState) => [...prevState, e.target.value]);
      return;
    }
    setButtons((prevState) =>
      prevState.filter((state) => state !== e.target.value)
    );
    setVisible((prevState) =>
      prevState.filter((state) => state !== e.target.value)
    );
  };
  
  const handleOther = (e) => {
    const name = e.target.getAttribute("name");
    const value = e.target.value;
    if (value === "Other") {
      setOtherFields((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      return;
    }
    setOtherFields((prevState) => {
      delete prevState[name];
      return {
        ...prevState,
      };
    });
  };
  function findOtherField(name) {
    const found = Object.keys(otherFields).find((field) => field === name);
    if (found) return found;
    return false;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dateOfBirth = e.target.querySelector('[name="Date of Birth"]');
    const dateOfBirthApproximate = e.target.querySelector(
      '[name="Date of Birth Approximate?"]'
    );
    const dateOfDeath = e.target.querySelector('[name="Date of Death"]');
    const dateOfDeathApproximate = e.target.querySelector(
      '[name="DOD Approximate?"]'
    );
    const dateMissing = e.target.querySelector('[name="Date Missing"]');
    const dateMissingApproximate = e.target.querySelector(
      '[name="Date Missing Approximate?"]'
    );
    const dateFound = e.target.querySelector('[name="Date Found"]');
    const dateFoundApproximate = e.target.querySelector(
      '[name="Date Found Approximate?"]'
    );
    const hairColor = e.target.querySelector('[name="Hair Color"]');
    const eyeColor = e.target.querySelector('[name="Eye Color"]');
    const gender = e.target.querySelector('[name="Gender"]');
    const heightFeet = e.target.querySelector('[name="Height Feet"]');
    const heightInches = e.target.querySelector('[name="Height Inches"]');
    const weight = e.target.querySelector('[name="Weight"]');
    const hairOther = e.target.querySelector('[name="Hair Other"]');
    const eyeOther = e.target.querySelector('[name="Eye Color Other"]');
    const race = e.target.querySelector('[name="Race"]');
    const raceOther = e.target.querySelector('[name="Race Other"]');
    const genderOther = e.target.querySelector('[name="Gender Other"]');
    const distinguishingCharacteristics = e.target.querySelector(
      '[name="Distinguishing Characteristics"]'
    );
    const otherInformation = e.target.querySelector(
      '[name="Other Information"]'
    );

    const selectorArr = [
      dateOfBirth,
      dateOfDeath,
      dateMissing,
      dateFound,
      hairColor,
      eyeColor,
      gender,
      heightFeet,
      weight,
      distinguishingCharacteristics,
      otherInformation,
      hairOther,
      eyeOther,
      genderOther,
      raceOther,
      race,
    ];

    const fieldValidArray = [];
    selectorArr.forEach((selector) => {
      if (selector) {
        if (selector.value === "") {
          setErrors((prevState) => {
            return {
              ...prevState,
              [selector.getAttribute("name")]: true,
            };
          });
          fieldValidArray.push("true");
          return;
        }

        setErrors((prevState) => {
          delete prevState[selector.getAttribute("name")];
          return {
            ...prevState,
          };
        });
        fieldValidArray.push("false");
      }

      for (const error in errors) {
        const findInput = buttons.find((button) => button === error);
        if (!findInput) {
          setErrors((prevState) => {
            delete prevState[error];
            return {
              ...prevState,
            };
          });
        }
      }
    });

    if (fieldValidArray.find((a) => a === "true")) return;

    const caseSlug = slug ?? router?.query?.slug;
    console.log("caseSlug", caseSlug);

    const fields = {
      "User ID": outsetaUserId || "undefined",
      "User email": user.email || user.name || "undefined",
      "Source URL": sourceUrl,
      "Case Slug": caseSlug,
    };
    const trackFields = {};
    buttons.forEach((button) => {
      if (button === "Race") return;
      if (button === "Victim Photo" || button === "Timeline") {
        fields[button] = true;
        return;
      }

      const buttonVal = e.target.querySelector(`[name="${button}"]`).value;
      fields[button] = buttonVal;
      if (buttonVal && buttonVal !== "") {
        trackFields[button] = buttonVal;
      }
    });
    if (dateOfBirthApproximate && dateOfBirthApproximate.checked) {
      fields["Date of Birth Approximate?"] = true;
      trackFields["DoB Approx"] = true;
    }
    if (dateOfDeathApproximate && dateOfDeathApproximate.checked) {
      fields["DOD Approximate?"] = true;
      trackFields["DoD Approx"] = true;
    }
    if (dateMissingApproximate && dateMissingApproximate) {
      fields["Date Missing Approximate?"] = true;
      trackFields["Date Missing Approx"] = true;
    }
    if (dateFoundApproximate && dateFoundApproximate) {
      fields["Date Found Approximate?"] = true;
      trackFields["Date Found Approx"] = true;
    }
    if (raceSelected) {
      fields["Race"] = raceSelected.map((race) => race.value);
      trackFields["Race"] = raceSelected.map((race) => race.value);
      if (raceSelected.find((race) => race.value == "Other")) {
        fields["Race Other"] = raceOther.value;
        trackFields["Race Other"] = raceOther.value;
      }
    }
    if (heightInches && heightInches.value !== "") {
      fields["Height Inches"] = heightInches.value;
      trackFields["Height Inches"] = heightInches.value;
    }

    setSubmitting(true);

    if (!slug) {
      track("missing_slug_on_source_submission", {
        slug: caseSlug,
      });
    }

    try {
      const res = await axios({
        url: `${location.origin}/api/case-submission`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer UK-t9E1O3sJLf-2E`,
        },
        data: {
          url: "https://api.airtable.com/v0/appUoUXV68dbvvCHx/User%20Source%20Submission",
          records: [
            {
              fields,
            },
          ],
        },
      });
      trackFields.slug = caseSlug;
      track("source_citation_details_submitted", trackFields);

      setSubmitting(false);
      if (res.data?.status === "success") {
        setSourceUrl("");
        setSteps("thankyou");
      }
    } catch (error) {
      console.log(error.message);
      setSubmitting(false);
    }
  };

  const handleRace = (selected) => {
    setRaceSelected(selected);
    for (const r in selected) {
      if (selected[r].value === "Other") {
        setOtherFields((prevState) => ({
          ...prevState,
          ["Race"]: "Other",
        }));
        return;
      }
      setOtherFields((prevState) => {
        delete prevState["Race"];
        return {
          ...prevState,
        };
      });
    }
  };

  return (
    <div className="-mt-5">
      <button
        className="text-red underline hover:no-underline mb-5"
        onClick={() => setSteps("addSource")}
      >
        {"<"}Back{" "}
      </button>
      <div className="bg-gray-150 rounded-md p-4 mb-10">
        <a
          href={sourceUrl}
          className="text-yellow-400 underline hover:no-underline"
        >
          {sourceUrl}
        </a>
      </div>
      <h3 className="mb-5">
        What information is present in this source (optional)?
      </h3>
      <div className="flex flex-wrap">
        <Button text="Date of Birth" handleClick={handleClick} />
        <Button text="Date of Death" handleClick={handleClick} />
        <Button text="Date Missing" handleClick={handleClick} />
        <Button text="Date Found" handleClick={handleClick} />
        <Button text="Hair Color" handleClick={handleClick} />
        <Button text="Eye Color" handleClick={handleClick} />
        <Button text="Gender" handleClick={handleClick} />
        <Button text="Race" handleClick={handleClick} />
        <Button text="Height Feet" handleClick={handleClick} />
        <Button text="Weight" handleClick={handleClick} />
        <Button
          text="Distinguishing Characteristics"
          handleClick={handleClick}
        />
        <Button
          text="Victim Photo"
          handleClick={handleClick}
          name="Victim Photo"
        />
        <Button text="Timeline" handleClick={handleClick} name="Timeline" />
        <Button text="Other Information" handleClick={handleClick} />
      </div>

      {buttons.length > 0 && (
        <div className="mt-10">
          {visible.length > 0 && (
            <>
              <h3 className="mb-0">
                Enter the information found in the source (optional)
              </h3>
            </>
          )}
          <form className="mt-6" onSubmit={handleSubmit}>
            {buttons.find((button) => button === "Date of Birth") && (
              <div>
                <label>Date of Birth</label>
                <div className="mb-6">
                  <div className="custom-date relative">
                    <input
                      type="date"
                      className="border w-full p-2 text-sm"
                      name="Date of Birth"
                    />
                  </div>
                  {errors["Date of Birth"] && (
                    <Error text="Date of birth is required!" />
                  )}
                  <label className="mt-2 inline-flex items-center cursor-pointer">
                    <input type="checkbox" name="Date of Birth Approximate?" />
                    <span className="ml-2 text-sm">Date is approximate</span>
                  </label>
                </div>
              </div>
            )}
            {buttons.find((button) => button === "Date of Death") && (
              <div>
                <label>Date of Death</label>
                <div className="mb-6">
                  <div className="custom-date relative">
                    <input
                      type="date"
                      className="border w-full border-gray-250 p-2 text-sm"
                      name="Date of Death"
                    />
                    {errors["Date of Death"] && (
                      <Error text="Date of death is required!" />
                    )}
                  </div>
                  <label className="mt-2 inline-flex items-center cursor-pointer">
                    <input type="checkbox" name="DOD Approximate?" />
                    <span className="ml-2 text-sm">Date is approximate</span>
                  </label>
                </div>
              </div>
            )}
            {buttons.find((button) => button === "Date Missing") && (
              <div>
                <label>Date Missing</label>
                <div className="mb-6">
                  <div className="custom-date relative">
                    <input
                      type="date"
                      className="border w-full p-2 text-sm border-gray-250"
                      name="Date Missing"
                    />
                  </div>
                  {errors["Date Missing"] && (
                    <Error text="Date Missing is required!" />
                  )}
                  <label className="mt-2 inline-flex items-center cursor-pointer">
                    <input type="checkbox" name="Date Missing Approximate?" />
                    <span className="ml-2 text-sm">Date is approximate</span>
                  </label>
                </div>
              </div>
            )}
            {buttons.find((button) => button === "Date Found") && (
              <div>
                <label>Date Found</label>
                <div className="mb-6">
                  <div className="custom-date relative">
                    <input
                      type="date"
                      className="border w-full p-2 border-gray-250"
                      name="Date Found"
                    />
                    {errors["Date Found"] && (
                      <Error text="Date Found is required!" />
                    )}
                  </div>
                  <label className="mt-2 inline-flex items-center cursor-pointer">
                    <input type="checkbox" name="Date Found Approximate?" />
                    <span className="ml-2 text-sm">Date is approximate</span>
                  </label>
                </div>
              </div>
            )}
            {buttons.find((button) => button === "Hair Color") && (
              <div className="mb-6">
                <div className="select-custom">
                  <select
                    className="w-full p-2 text-sm"
                    name="Hair Color"
                    onChange={handleOther}
                  >
                    <option value="" style={{ display: "none" }}>
                      Hair Color
                    </option>
                    <option value="Black">Black</option>
                    <option value="Red">Red</option>
                    <option value="White">White</option>
                    <option value="Brown">Brown</option>
                    <option value="Grey/Partially Grey">
                      Grey/Partially Grey
                    </option>
                    <option value="Blonde">Blonde</option>
                    <option value="Bald">Bald</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                {errors["Hair Color"] && (
                  <Error text="Hair Color is required!" />
                )}
                {findOtherField("Hair Color") && (
                  <>
                    <input
                      type="text"
                      placeholder="other"
                      className="border px-3 py-2 w-full text-sm mt-2 border-gray-250"
                      name="Hair Other"
                    />
                    {errors["Hair Other"] && (
                      <Error text="Hair Other is required!" />
                    )}
                  </>
                )}
              </div>
            )}
            {buttons.find((button) => button === "Eye Color") && (
              <div className="mb-6">
                <div className="select-custom">
                  <select
                    className="w-full p-2 text-sm"
                    name="Eye Color"
                    onChange={handleOther}
                  >
                    <option value="" style={{ display: "none" }}>
                      Eye Color
                    </option>
                    <option value="Black">Black</option>
                    <option value="Blue">Blue</option>
                    <option value="Brown">Brown</option>
                    <option value="Green">Green</option>
                    <option value="Grey">Grey</option>
                    <option value="Hazel">Hazel</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                {errors["Eye Color"] && <Error text="Eye Color is required!" />}
                {findOtherField("Eye Color") && (
                  <>
                    <input
                      type="text"
                      placeholder="other"
                      className="border px-3 py-2 w-full text-sm mt-2 border-gray-250"
                      name="Eye Color Other"
                    />
                    {errors["Eye Color Other"] && (
                      <Error text="Eye Color Other is required!" />
                    )}
                  </>
                )}
              </div>
            )}
            {buttons.find((button) => button === "Gender") && (
              <div className="mb-6">
                <div className="select-custom">
                  <select
                    className="w-full p-2 text-sm"
                    name="Gender"
                    onChange={handleOther}
                  >
                    <option value="" style={{ display: "none", color: "#ccc" }}>
                      Gender
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Non-Binary">Non-Binary</option>
                    <option value="Transgender">Transgender</option>
                    <option value="Intersex">Intersex</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                {errors["Gender"] && <Error text="Gender is required!" />}
                {findOtherField("Gender") && (
                  <>
                    <input
                      type="text"
                      placeholder="other"
                      className="border px-3 py-2 w-full text-sm mt-2 border-gray-250"
                      name="Gender Other"
                    />
                    {errors["Gender Other"] && (
                      <Error text="Gender Other is required!" />
                    )}
                  </>
                )}
              </div>
            )}
            {buttons.find((button) => button === "Race") && (
              <div className="mb-6">
                <Select
                  value={raceSelected}
                  onChange={handleRace}
                  options={raceOptions}
                  isMulti={true}
                  placeholder="Race"
                  name="Race"
                />

                {errors["Race"] && <Error text="Race is required!" />}
                {findOtherField("Race") && (
                  <>
                    <input
                      type="text"
                      placeholder="other"
                      className="border px-3 py-2 w-full text-sm mt-2 border-gray-250"
                      name="Race Other"
                    />
                    {errors["Race Other"] && (
                      <Error text="Race Other is required!" />
                    )}
                  </>
                )}
              </div>
            )}
            {buttons.find((button) => button === "Height Feet") && (
              <div className="mb-6">
                <label className="text-gray-400 font-bold mb-2 text-xs block">
                  Height
                </label>
                <div className="flex flex-wrap">
                  <input
                    type="number"
                    placeholder="Feet"
                    className="border px-3 py-2 w-45 text-sm border-gray-250"
                    name="Height Feet"
                  />
                  <input
                    type="number"
                    placeholder="Inches"
                    className="border px-3 py-2 w-45 ml-auto text-sm border-gray-250"
                    name="Height Inches"
                  />
                </div>
                {errors["Height Feet"] && (
                  <Error text="Height Feet is required!" />
                )}
              </div>
            )}
            {buttons.find((button) => button === "Weight") && (
              <div className="mb-6">
                <input
                  type="number"
                  placeholder="Weight (lbs)"
                  className="border px-3 py-2 w-full text-sm border-gray-250"
                  name="Weight"
                />
                {errors["Weight"] && <Error text="Weight is required!" />}
              </div>
            )}
            {buttons.find(
              (button) => button === "Distinguishing Characteristics"
            ) && (
              <div className="mb-6">
                <textarea
                  className="border px-3 py-2 w-full text-sm border-gray-250"
                  placeholder="Distinguishing Characteristics"
                  rows="3"
                  name="Distinguishing Characteristics"
                ></textarea>
                {errors["Distinguishing Characteristics"] && (
                  <Error text="Distinguishing Characteristics is required!" />
                )}
              </div>
            )}

            {buttons.find((button) => button === "Other Information") && (
              <div className="mb-6">
                <textarea
                  className="border px-3 py-2 w-full text-sm border-gray-250"
                  placeholder="Other Information"
                  rows="3"
                  name="Other Information"
                ></textarea>
                {errors["Other Information"] && (
                  <Error text="Other Information is required!" />
                )}
              </div>
            )}
            <div className="flex">
              <button
                className={`ml-auto font-bold rounded-md px-10 py-2 transition mt-5  ${
                  submitting
                    ? "cursor-not-allowed bg-gray-200 text-gray-400"
                    : "hover:bg-yellow-600 bg-yellow-400 text-white"
                }`}
                type="submit"
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
